/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DischargeSummary from './discharge-summary';
import DischargeSummaryDetail from './discharge-summary-detail';
import DischargeSummaryUpdate from './discharge-summary-update';
import DischargeSummaryDeleteDialog from './discharge-summary-delete-dialog';

const DischargeSummaryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DischargeSummary />} />
    <Route path="new" element={<DischargeSummaryUpdate />} />
    <Route path=":id">
      <Route index element={<DischargeSummaryDetail />} />
      <Route path="edit" element={<DischargeSummaryUpdate />} />
      <Route path="delete" element={<DischargeSummaryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DischargeSummaryRoutes;
